import { forwardRef } from "react";

import { Icon, StyledButton } from "./styles";

type Props = {
  className?: string;
  onClick?: () => void;
};

export const ArticleCommentsIcon = forwardRef<HTMLButtonElement, Props>(
  ({ className, onClick }, reference) => (
    <StyledButton className={className} onClick={onClick} ref={reference}>
      <Icon />
    </StyledButton>
  ),
);

ArticleCommentsIcon.displayName = "ArticleCommentsIcon";
